import React from 'react';
import './ValueProposition.css';

function ValueProposition() {
  const features = [
    {
      icon: '💰',
      title: 'Lowest Price Guarantee',
      description: 'We offer the most competitive rates in the market, guaranteed 20% cheaper than competitors'
    },
    {
      icon: '🔒',
      title: '100% Secure',
      description: 'Your data and payments are completely secure with our encrypted platform'
    },
    {
      icon: '🕐',
      title: '24/7 Support',
      description: 'Our dedicated team is available round the clock to assist you'
    }
  ];

  const comparisonData = [
    {
      feature: 'Matrimonial Ad',
      competitor: '₹2,500*',
      us: '₹2,000*',
      savings: '20%'
    },
    {
      feature: 'Property Ad',
      competitor: '₹3,000*',
      us: '₹2,400*',
      savings: '20%'
    },
    {
      feature: 'Recruitment Ad',
      competitor: '₹4,000*',
      us: '₹3,200*',
      savings: '20%'
    },
    {
      feature: 'Public Notice',
      competitor: '₹3,500*',
      us: '₹2,800*',
      savings: '20%'
    }
  ];

  return (
    <section className="value-proposition">
      <div className="container">
        <h2 className="section-title">Why Choose Us?</h2>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-large">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="comparison-section">
          <h3 className="comparison-title">Price Comparison</h3>
          <p className="comparison-subtitle">See how much you can save with BookMyNewsAd</p>
          
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Ad Type</th>
                  <th>Competitors</th>
                  <th className="highlight-col">BookMyNewsAd</th>
                  <th>You Save</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.feature}</td>
                    <td className="competitor-price">{row.competitor}</td>
                    <td className="our-price highlight-col">{row.us}</td>
                    <td className="savings">{row.savings}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          <p className="comparison-note">
            * Prices are indicative and may vary based on newspaper and ad specifications
          </p>
        </div>
      </div>
    </section>
  );
}

export default ValueProposition;
